import { AppShell } from "@mantine/core";
import { Outlet } from "react-router-dom";
import AppHeader from "../../src/components/Header";
import NavBar from "../../src/components/NavBar";

export const Layout = (): JSX.Element => {
	return (
		<AppShell
			padding={0}
			navbarOffsetBreakpoint="sm"
			fixed
			className="bg-primaryBg"
			navbar={<NavBar />}
			header={<AppHeader />}
		>
			<div>
				<Outlet />
			</div>
		</AppShell>
	);
};
